export default __webpack_public_path__ + "static/media/home-mob-bg4.e9deebac.png";